<script setup lang="ts">
  defineOptions({ name: 'EventsDirectoryNavbarSearch' })

  import { useI18n } from 'vue-i18n'

  import { SearchLgIcon } from '@gohighlevel/ghl-icons/24/outline'

  import { createElementId } from '@common/core-layer/utils'

  import CPInput from '@ui/components/CPInput.vue'

  import { useEventsDirectorySearch } from '../../composables/useEventsDirectorySearch'

  const { t } = useI18n()

  const { searchQuery, setSearchQuery } = useEventsDirectorySearch()

  const handleInput = (value: string) => {
    setSearchQuery(value)
  }
</script>

<template>
  <CPInput
    :id="createElementId('events-directory', 'navbar', 'search')"
    :model-value="searchQuery"
    size="sm"
    class="events-directory-search w-full"
    :placeholder="t('clientportal.events.searchPlaceholder')"
    :aria-label="t('clientportal.events.searchAriaLabel')"
    :prefix-icon="SearchLgIcon"
    clearable
    @update:model-value="handleInput"
  />
</template>

<style>
  /*
   * Light mode keeps the search field's pre-dark-mode look: CPInput now paints placeholder and
   * prefix/suffix in --cp-font-500. Dark mode keeps CPInput's tokens.
   */
  html:not([data-theme='dark']) .events-directory-search {
    --n-placeholder-color: color-mix(in oklab, var(--cp-brand-font) 40%, transparent) !important;
  }

  html:not([data-theme='dark']) .events-directory-search .hr-input-wrapper {
    background-color: var(--cp-background-500) !important;
  }

  html:not([data-theme='dark']) .events-directory-search input::placeholder {
    color: color-mix(in oklab, var(--cp-brand-font) 40%, transparent) !important;
    -webkit-text-fill-color: color-mix(in oklab, var(--cp-brand-font) 40%, transparent) !important;
  }

  html:not([data-theme='dark']) .events-directory-search .hr-input__prefix,
  html:not([data-theme='dark']) .events-directory-search .hr-input__suffix {
    color: var(--cp-brand-font) !important;
  }
</style>
